
import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';

import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ReportsubmissionComponent } from './reportsubmission/reportsubmission.component';
import { GroupmodalComponent } from './groupmodal/groupmodal.component'
import { AdobelaunchService } from './_services/adobelaunch.service';
import { CompanyService } from './company/company.service';
@Component({
    selector: 'app-openmodal',
    template: '',
    standalone: false
})

export class ModalContainerComponent implements OnDestroy, AfterViewInit {
    destroy = new Subject<any>();
    currentDialog = null;
    compno: string;
    currentYear: number;
    prfNumber: string;
    prfName: string;

    constructor(
        private modalService: NgbModal, private location: Location,
        route: ActivatedRoute,private AdobelaunchService:AdobelaunchService,
        router: Router, private readonly companyService: CompanyService
    ) {
        this.compno = this.companyService.companyId;
    this.currentYear = this.companyService.currentYear;
    this.prfNumber = this.companyService.prfNumber;
        route.params.pipe(takeUntil(this.destroy)).subscribe(params => {
            // When router navigates on this component, opens up the submission modal
            if (router.routerState.snapshot.url.includes('/PRFSubmission')) {
                this.currentDialog = this.modalService.open(ReportsubmissionComponent, { windowClass: "finalSubmissionModal" });
                // Go back/home page after the modal is closed/dismissed
                this.currentDialog.result.then(result => {
                    if (result == 'withNavigateToPremiumReport') {
                            router.navigate([`/${this.currentYear}/${encodeURIComponent(this.prfNumber)}/premiumreport`]);
                    }
                    else if (result === 'withValidationSummary') {
                            router.navigate([`/${this.currentYear}/${encodeURIComponent(this.prfNumber)}/validationsummary`]);
                    }
                    else if (result === 'withNavigateToGroupReporting') {
                        router.navigate([`/${this.currentYear}/${encodeURIComponent(this.prfNumber)}/groupreporting`]);
                    }
                    else if (result === 'PRFSubmissionComplete') {
                        router.navigate([`/${this.currentYear}/${encodeURIComponent(this.prfNumber)}/validationsummary`]);
                    }
                    else {
                        this.location.back();
                    }
                }, reason => {
                    router.navigateByUrl('/dboard');
                });
            }
            else {
                this.modalService.dismissAll()
                this.currentDialog = this.modalService.open(GroupmodalComponent);
                this.currentDialog.result.then((result) => {
                    if (result == "Close") {
                        router.navigate(['/dboard']);
                    }
                });
            }


        });
    }
    ngAfterViewInit() {
        this.AdobelaunchService.EventEndDispatch();
        }
    ngOnDestroy() {
        this.destroy.next(null);
    }
}
